export const endPoint =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3003'
    : '';

export const loginResponse = {
  companyName: 'companyName',
  managerName: 'managerName',
  token: 'token'
};

import axios from 'axios';

let baseUrl = "http://localhost:3003"
if (document.URL.indexOf('localhost') > -1) {
  baseUrl = 'http://localhost:3003'
}else if (document.URL.indexOf('staging.internal.backstage.gladmobile.com')){
  baseUrl = 'https://test-fleet.gladmobile.com'
}

export let webServer = axios.create({
  baseURL: baseUrl,
  timeout: 1000*5
});
webServer.interceptors.response.use( (response) => {
  return response.data;
}, (error) => {
  if(error.response.status >= 500){
    alert('伺服器發生錯誤，請聯絡管理人員')
  }
  return Promise.reject(error.response);
});




// WEBPACK FOOTER //
// ./src/utilities/api.js